import axios, { AxiosInstance } from 'axios';

import { InitApi } from './types';
import config from './config';

const errorHandler = (error: unknown) => {
  console.error(error);
};

const initApi: InitApi = (apiConfig) => {
  const { protocol } = window.location;
  const baseURL = apiConfig?.baseURL?.replace('http:', protocol);

  const apiInstance: AxiosInstance = axios.create({
    baseURL,
    timeout: apiConfig?.timeout,
    headers: {
      ...apiConfig?.headers
    }
  });

  apiInstance.interceptors.response.use((response) => response, errorHandler);

  return apiInstance;
};

export const apiLSNext = initApi(config?.LSNextApi);

export default { apiLSNext };
